export default __webpack_public_path__ + "img/phone-illustration.1248071b.svg";